import React, { useEffect, useRef, useState } from 'react';
import {
  DialogTitle,
  DialogContent,
  Grid,
  LinearProgress,
  Paper,
  Typography
} from '@material-ui/core';
import Draggable from 'react-draggable';
import { PrintQrCodeScannerDialogContainer } from '../../styles';
import { Html5Qrcode } from 'html5-qrcode';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggablePrintQrCodeScannerDialog"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}


function PrintQrCodeScannerDialog({ open, onClose, onDetected }) {
  const [loading, setLoading] = useState(false);

  const scannerRef = useRef(null);

  useEffect(() => {
    let isHandled = false;

    if (open) {
      const timeout = setTimeout(() => {
        const element = document.getElementById('qr-reader');

        if (element) {
          const html5QrCode = new Html5Qrcode('qr-reader');

          html5QrCode
            .start(
              { facingMode: 'environment' },
              { fps: 15, qrbox: 250 },
              async (decodedText) => {
                if (isHandled) return;
                isHandled = true;

                if (scannerRef.current) {
                  try {
                    await scannerRef.current.stop();
                    await scannerRef.current.clear();
                  } catch (err) {
                    console.warn('Erro ao parar scanner (onDetected):', err);
                  }
                  scannerRef.current = null;
                }

                // Remove caracteres nulos e espaços em branco do decodedText
                const cleanDecodedText = decodedText?.replace(/\0/g, '').trim();
                onDetected(cleanDecodedText);
              },
              () => {}
            )
            .then(() => {
              scannerRef.current = html5QrCode;
            })
            .catch((err) => {
              console.error('Erro ao iniciar scanner:', err);
            });
        }
      }, 200);

      return () => {
        clearTimeout(timeout);

        if (scannerRef.current) {
          scannerRef.current
            .stop()
            .then(() => scannerRef.current.clear())
            .then(() => {
              scannerRef.current = null;
            })
            .catch((err) => {
              console.warn('Erro ao parar scanner (cleanup):', err);
            });
        }
      };
    }
  }, [open, onDetected]);

  return (
    <PrintQrCodeScannerDialogContainer
      className="defaultModal"
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperComponent={PaperComponent}
    >
      <DialogTitle
        className="modalHeader lightBlue bold textAlignCenter cursorMove"
        id="draggablePrintQrCodeScannerDialog"
      >
        <Typography className="w100 textAlignCenter">
          LER QR CODE DAS ETIQUETAS
        </Typography>
      </DialogTitle>

      {loading ? <LinearProgress /> : null}

      <DialogContent>
        <Grid
          container
          spacing={6}
          className="w100 alignCenter justifyCenter m0"
        >
          <div id="qr-reader" style={{ width: '100%' }} />
        </Grid>
      </DialogContent>
    </PrintQrCodeScannerDialogContainer>
  );
}

export default PrintQrCodeScannerDialog;
